import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

const Toggle = (props) => {
  const [toggle, setToggle] = useState(props.toggle)
  useEffect(() => {
    setToggle(Boolean(props.toggle))
  }, [props.toggle])

  return (
    <>
      {!toggle && props.children}
    </>
  )
}

Toggle.propTypes = {
  children: PropTypes.element.isRequired,
  toggle: PropTypes.bool
}

Toggle.defaultProps = {
  toggle: false
}

export default Toggle
